module.exports = __webpack_public_path__ + "img/Ins_Volt_L2.ef994e0d.jpeg";